module.exports = __webpack_public_path__ + "assets/img/yl_w_d_i_5.cd0ac9e1.jpg";